import React from 'react'
import { StyleSelectorFormsy } from 'app/main/notification/components/StyleSelectFormsy'
import { MenuItem } from '@material-ui/core'
import * as R from 'ramda'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  menuItem: {
    [theme.breakpoints.down('xs')]: {
      whiteSpace: 'unset !important',
    },
  },
}))

const CustomStatelessSelector = (props) => {
  const { items, selectedItemId, ValidComp, firstMenu, value, ...rest } = props
  const isInValid = R.anyPass([R.isNil, R.isEmpty])
  const classes = useStyles()
  return (
    <StyleSelectorFormsy
      {...rest}
      value={value}
      FormControlProps={{
        disabled: isInValid(items),
      }}
    >
      {firstMenu ? <div>{firstMenu}</div> : null}
      {isInValid(items)
        ? null
        : items.map((item) => (
            <MenuItem key={item.id} value={item} className={classes.menuItem}>
              {ValidComp(item)}
            </MenuItem>
          ))}
    </StyleSelectorFormsy>
  )
}

const MenuPropTypes = {
  id: PropTypes.any.isRequired,
  name: PropTypes.node,
}
CustomStatelessSelector.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.shape(MenuPropTypes)).isRequired,
  selectedItemId: PropTypes.any,
}

export default React.memo(CustomStatelessSelector)
